import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=5022632b&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=5022632b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022632b",
  null
  
)

export default component.exports